import { APPLY_NOTIFICATION_TOKEN } from '../constants/actionTypes'

const INITIAL_STATE = {
    open: false,
    newNotification: null,
    notifications: {},
    notificationCounter: 0,
    notificationToken: '',
    inAppNotoficationVisable: false,
    
  };
  
const applyNewNotification = (state, action) => {
    const notId = action.payload.collapse_key
    const notData = Object.assign(action.payload, {visible: true} )
  
    return ({
      ...state,
      newNotification: action.payload,
      notifications: {
        ...state.notifications,
        [notId]: notData,
      },
      notificationCounter: state.notificationCounter+1

  });
}

const applyToggleNotification = (state, action) => {
  const notId = action.payload.notId
  const visible = action.payload.visible
  return {
    ...state,
    notifications: {
      ...state.notifications,
      [notId]:{
        ...state.notifications[notId],
        visible: visible,
      }
    },
    notificationCounter: state.notificationCounter-1
  }
}

const applyNotificationToken = (state, action)=>{
  //console.log(action)
    return {
      ...state,
      notificationToken: action.payload
    }

}

  function notificationReducer(state = INITIAL_STATE, action) {
   
    switch(action.type) {
      case 'NEW_NOTIFICATION' : {
    
        return applyNewNotification(state, action);
      }
      case 'TOGGLE_NOTIFICATION' : {
        return applyToggleNotification(state, action);
      }
      case APPLY_NOTIFICATION_TOKEN: {
        return applyNotificationToken(state, action)
      }
      case 'IN_APP_NOTIFICATION': {
        return {
          ...state,
          inAppNotoficationVisable: action.payload
        }
      }
      default : return state;
    }
  }
  
  export default notificationReducer;


// WEBPACK FOOTER //
// ./src/reducers/notification.js